import { useCallback } from 'react';
import { useUpdateClipMutation } from '../../operation.generated';
import { useEventsContext } from '../../../../context/events/EventsContext';
import { StudioClipsDataAndActions } from './common';
import { toast } from '../../../Toaster';
import { getApolloMutationErrorMessage } from '../../../../util/apolloError';

const useRenameClip = () => {
  const [eventTracking] = useEventsContext();
  const showUpdateClipError = useCallback((message?: string) => {
    const isDefaultMessage = message?.includes('Failed to update clip');
    const toastMessage =
      message && !isDefaultMessage
        ? message
        : 'Something went wrong. Please try again.';
    toast({
      message: toastMessage,
      type: 'error',
    });
  }, []);
  const [updateClip] = useUpdateClipMutation({
    onCompleted: data => {
      if (data.updateClip.success) {
        eventTracking.trackClipRenamed({
          clipName: data.updateClip.clip?.name || '',
        });
        return;
      }
      showUpdateClipError(data.updateClip.message);
    },
    onError: error => {
      showUpdateClipError(
        getApolloMutationErrorMessage(error, 'Failed to update clip')
      );
    },
  });
  const renameClip = useCallback<StudioClipsDataAndActions[1]['renameClip']>(
    async (clip, newName) => {
      if (clip.name === newName) {
        return;
      }
      try {
        await updateClip({
          variables: {
            inputs: {
              clipId: clip.id,
              name: newName,
            },
          },
          optimisticResponse: {
            updateClip: {
              __typename: 'UpdateClipMutationResponse',
              clip: {
                ...clip,
                name: newName,
              },
              success: true,
              message: 'updated',
              code: 'graphql_mutation_success',
            },
          },
        });
      } catch (error) {
        // onError handles user-facing feedback; catch prevents uncaught promise rejections.
      }
    },
    [updateClip]
  );
  return renameClip;
};

export default useRenameClip;
